import { GridColumnProps } from '@progress/kendo-vue-grid';
import { SortDescriptor } from '@progress/kendo-data-query';

const getLetterSpacingValue = (letter: string): number => {
  switch (letter) {
    case (' '):
    case ('j'):
    case ('i'):
    case ('I'):
    case ('l'):
      return 6;

    case ('r'):
    case ('t'):
    case ('f'):
      return 6;

    case ('k'):
    case ('L'):
    case ('s'):
      return 7;

    case ('b'):
    case ('E'):
    case ('q'):
      return 8;

    case ('p'):
    case ('Z'):
    case ('B'):
    case ('C'):
    case ('K'):
    case ('F'):
    case ('P'):
    case ('R'):
    case ('S'):
    case ('T'):
      return 9;

    case ('X'):
    case ('A'):
    case ('H'):
    case ('D'):
    case ('G'):
    case ('Y'):

    case ('N'):
    case ('Q'):
    case ('U'):
    case ('V'):
      return 10;

    case ('O'):
      return 11;

    case ('m'):
    case ('M'):
      return 12;
  }
  return 8;
}

const generateColumnWidth = (value: string) => {
  const sum = [...value].reduce((carry, current) => {
    const space = getLetterSpacingValue(current);
    //@ts-ignore
    return carry + space;
  }, 30)

  return sum;
}

export const generateColumnHeadings = (results: any[], sort: SortDescriptor[] | null): GridColumnProps[] => {
  if (results.length >= 1) {
    // Get all heading keys into an array
    const headingKeys = Object.keys(results[0]);
    // Create a map of each heading and generate its default width based off the heading text
    const headingSizes = new Map(headingKeys.map(h => ([h, generateColumnWidth(h)])));
    // Map over all available results we have and check if the content is bigger than the heading.
    results.forEach(result => {
      headingKeys.forEach(h => {
        if (typeof result[h!] === 'string') {
          const width = generateColumnWidth(result[h!]);
          if (headingSizes.has(h) && width >= headingSizes.get(h)!) {
            headingSizes.set(h, width);
          }
        }
      })
    });
    return headingKeys.map(i => {
      const sortPadding = sort && sort.find((f) => f.field === i) ? 20 : 0;
      return {
        field: i,
        width: Number(headingSizes.get(i)) + sortPadding,
      }
    }) as GridColumnProps[];
  }
  return [{
    field: '',
    headerClassName: 'k-no-results',
    width: 500,
  }]
}

export default generateColumnWidth;